var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{class:{ 'logo-photonow': !_vm.customCSS },style:({ width: _vm.width }),attrs:{"src":require("@/assets/logo.png"),"draggable":"false"},on:{"contextmenu":function($event){$event.preventDefault();},"dragstart":function($event){$event.preventDefault();}}})
}
var staticRenderFns = []

export { render, staticRenderFns }